/** @format */

import React, { useEffect, useState } from "react";
import PanToolIcon from "@mui/icons-material/PanTool";
import Tooltip from "@mui/material/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { handleDragToggleButton } from "../../../../store/reducers/pdfeditor/toolsModificationSlice";
import { TbReplace } from "react-icons/tb";
import { deleteCoordinate } from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import { modifiedCoordinateFunc } from "../../../../store/reducers/pdfeditor/pdfAddedRemovedCoordSlice";
function ToolBarImage({
  position,
  coordinate,
  handleImageUpload,
  imageUrl,
  setSelectedBoxId,
}) {
  const dispatch = useDispatch();
  const { eraseToggleButton } = useSelector((state) => state.toolsModification);
  const [enableDraggingErase, setEnableDraggingErase] = useState(false);
  const { coordinates } = useSelector((state) => state.pdfCoordinates);
  const handleDragToggle = () => {
    setEnableDraggingErase((prev) => {
      const newEnableDraggingText = !prev;
      dispatch(handleDragToggleButton(newEnableDraggingText));
      return newEnableDraggingText;
    });
  };

  const handleReplacetoggle = () => {
    handleImageUpload();
  };

  useEffect(() => {
    setEnableDraggingErase(eraseToggleButton);
  }, [eraseToggleButton]);

  const findRemovedCoord = (id) => {
    const removedCoord = coordinates.find((item) => item.id === id);
    if (removedCoord) {
      dispatch(modifiedCoordinateFunc({ ...removedCoord, action: "removed" }));
    }
  };
  const handleDeleteVariable = (id) => {
    dispatch(deleteCoordinate(id));
    findRemovedCoord(id);
  };

  return (
    <div
      style={{
        position: "absolute",
        left: `${position.prex}px`,
        top: `${position.prey - 38}px`,
        zIndex: 4,
      }}
    >
      <div
        style={{
          display: "flex",
          border: "1px solid #1976d2",
          background: "#fff",
          borderRadius: "5px",
          height: "38px",
          boxShadow: "0 0 10px 1px #1976d2",
        }}
      >
        {/* Drag Box */}
        <Tooltip title={`Toggle Drag`} placement='bottom'>
          <PanToolIcon
            // onClick={() => handleDragToggle()}
            onClick={() => setSelectedBoxId(null)}
            sx={{
              borderRadius: enableDraggingErase ? "5px" : "5px",
              color: enableDraggingErase ? "#fff" : "#1976d2",
              padding: "7px",
              background: enableDraggingErase ? "#1976d2" : "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>

        {imageUrl && (
          <>
            <div
              style={{ width: "1px", height: "100%", background: "#1976d2" }}
            ></div>

            <Tooltip title={`Replace Image`} placement='bottom'>
              <TbReplace
                onClick={() => handleReplacetoggle()}
                style={{
                  borderRadius: "5px",
                  color: "#1976d2",
                  padding: "7px",
                  background: "white",
                }}
                // size={32}
              />
            </Tooltip>
          </>
        )}
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>
        {/* *********Delete Box********* */}
        <Tooltip title={`Delete`} placement='bottom'>
          <DeleteIcon
            onClick={() =>
              handleDeleteVariable(coordinate?.id || coordinate?.variable)
            }
            sx={{
              borderRadius: coordinate?.color ? "5px" : "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default ToolBarImage;
